export default function PrivacyRoute() {
	return (
		<div className="container mx-auto max-w-3xl py-16">
			<h1 className="text-h2 mb-8">Politica de Confidențialitate</h1>

			<div className="prose prose-slate dark:prose-invert max-w-none">
				<p className="text-muted-foreground">
					Ultima actualizare: Februarie 2026
				</p>

				<h2>1. Introducere</h2>
				<p>
					Matematix (&ldquo;noi&rdquo;, &ldquo;al nostru&rdquo;) respectă
					confidențialitatea utilizatorilor săi. Această politică descrie cum
					colectăm, folosim și protejăm datele personale.
				</p>

				<h2>2. Date colectate</h2>
				<p>Colectăm următoarele categorii de date:</p>
				<ul>
					<li>
						<strong>Date de cont:</strong> adresa de email, numele de utilizator,
						parola (criptată)
					</li>
					<li>
						<strong>Profil de studiu:</strong> profilul de Bacalaureat (M1/M2),
						clasa
					</li>
					<li>
						<strong>Date de utilizare:</strong> progresul la lecții, răspunsurile
						la exerciții, istoricul recapitulărilor, statisticile de învățare
					</li>
					<li>
						<strong>Date tehnice:</strong> adresa IP, tipul de browser,
						preferințele de temă
					</li>
				</ul>

				<h2>3. Scopul prelucrării</h2>
				<p>Folosim datele pentru:</p>
				<ul>
					<li>Furnizarea și personalizarea serviciului de învățare</li>
					<li>Calcularea progresului și a recomandărilor de studiu</li>
					<li>Îmbunătățirea platformei</li>
					<li>Comunicări legate de cont și serviciu</li>
				</ul>

				<h2>4. Baza legală (GDPR)</h2>
				<p>
					Prelucrăm datele pe baza: consimțământului, executării contractului și
					interesului legitim.
				</p>

				<h2>5. Partajarea datelor</h2>
				<p>
					Nu vindem date personale. Partajăm date doar cu furnizorii de servicii
					necesari (hosting, email, plăți) pe baza unor contracte de prelucrare.
				</p>

				<h2>6. Retenția datelor</h2>
				<p>
					Păstrăm datele contului atât timp cât contul este activ. Datele de
					utilizare sunt păstrate pentru a furniza serviciul. Puteți solicita
					ștergerea datelor oricând.
				</p>

				<h2>7. Drepturile tale</h2>
				<p>Aveți dreptul de a:</p>
				<ul>
					<li>Accesa datele personale</li>
					<li>Rectifica datele incorecte</li>
					<li>Șterge datele (&ldquo;dreptul de a fi uitat&rdquo;)</li>
					<li>Exporta datele într-un format portabil</li>
					<li>Retrage consimțământul</li>
				</ul>

				<h2>8. Minori</h2>
				<p>
					Pentru utilizatorii sub 16 ani, consimțământul părintelui/tutorelui
					este necesar. Oferim un mecanism de consimțământ parental.
				</p>

				<h2>9. Contact</h2>
				<p>
					Pentru întrebări legate de confidențialitate, contactați-ne la{' '}
					<a href="mailto:privacy@matematix.ro">privacy@matematix.ro</a>.
				</p>
			</div>
		</div>
	)
}
